import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { VendorActionTypes, VendorActions } from "../../../actionTypes/master/vendorActionTypes";

import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  createVendorApi,
  editVendorDataByIdApi,
  getVendorDataByIdApi,
  getVendorListApi,
} from "../../requests/master/vendorRequests";
import {
  getVendorList,
  setVendorDataById,
  setVendorList,
  setVendorListPageCount,
} from "../../../actions/master/vendorActions";


function* createVendorHandler(action: VendorActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createVendorApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVendorListHandler(action: VendorActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getVendorListApi, action.payload);

    if (data.status) {
      yield put(setVendorList(data?.data?.rows));
      yield put(setVendorListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVendorDataByIdHandler(action: VendorActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getVendorDataByIdApi, action.payload);
    if (data.status) {
      yield put(setVendorDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editVendorDataByIdHandler(action: VendorActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editVendorDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getVendorList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// vendor sagas
export default function* vendorSaga() {
  yield takeLatest(VendorActions.CREATE_VENDOR, createVendorHandler);
  yield takeLatest(VendorActions.GET_VENDOR_LIST, getVendorListHandler);
  yield takeLatest(VendorActions.GET_VENDOR_DATA_BY_ID, getVendorDataByIdHandler);
  yield takeLatest(VendorActions.EDIT_VENDOR_DATA_BY_ID, editVendorDataByIdHandler);
}
